import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { TranslateLoader, TranslationObject } from '@ngx-translate/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TranslateLoaderService implements TranslateLoader {
  #httpClient: HttpClient = inject(HttpClient);

  getTranslation(lang: string): Observable<TranslationObject> {
    return this.#httpClient.get<TranslationObject>(`./i18n/${lang}.json`);
  }
}
